
// ROUTES
require('modules/event-field/routes/event-field');

// CONTROLLERS
require('modules/event-field/controllers/event-field');
require('modules/event-field/controllers/list');
require('modules/event-field/controllers/create');
require('modules/event-field/controllers/edit');

// SERVICES
require('modules/event-field/services/event-field');
require('modules/event-field/services/list');
require('modules/event-field/services/create');
require('modules/event-field/services/edit');
require('modules/event-field/services/delete');


angular.module('unica_event_field', [

	// ROUTES
	'unica_event_field.event_field_routes',

	// CONTROLLERS
	'unica_event_field.event_field_controllers',

	// SERVICES
	'unica_event_field.event_field_services'

]);


